import {AsyncInlineError, tracer} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

import {ShowLastCallRequestValueObject} from '../ValueObjects/ShowLastCallRequestValueObject.js'

/**
 * @implements UseCase
 */
export class ShowLastCallUseCase extends UseCase {
  /**
   * @constructor
   * @param {Object} deps
   * @param {LastCallRepository} deps.repository
   */
  constructor({config, repository}) {
    super()
    this._config = config
    this._repository = repository
  }

  /**
   * @return {Promise<Object, Error>}
   */
  @tracer({metric: 'ShowLastCallUseCase#execute'})
  @AsyncInlineError()
  async execute({adId, makeId, userId, offerTypeId}) {
    const showLastCallRequestValueObject = ShowLastCallRequestValueObject.create({adId, makeId, userId, offerTypeId})
    const isMotos = this._config.get('APP_NAME') === this._config.get('APP_NAME_MOTOS')
    const {OFFER_TYPE_NEW, OFFER_TYPE_KM0} = this._config.get('search')
    if (isMotos || ![OFFER_TYPE_KM0, OFFER_TYPE_NEW].includes(offerTypeId)) {
      return Promise.resolve({show: false, reason: 'LAST_CALL_NOT_SUPPORTED'})
    }
    const [showLastCallError, showLastCallResponse] = await this._repository.showLastCall({
      showLastCallRequestValueObject
    })

    if (showLastCallError) return Promise.reject(showLastCallError)

    return Promise.resolve(showLastCallResponse.toJSON())
  }
}
